import { combineReducers } from "redux";
import Dummy from "./Dummy";
import ViewControl from "./ViewControl";
const Reducer = combineReducers({
  Dummy,
  ViewControl
});
export default Reducer;
